import React from 'react';
import { Checkbox, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { NonDeliveryDaysStyles } from './non-delivery-days.styles';
import { WEEKDAYS } from './non-delivery-days.constants';
import { WeekdayCheckboxRowProps } from './non-delivery-days.interface';

const useStyles = makeStyles(NonDeliveryDaysStyles);

export const WeekdayCheckboxRow: React.FC<WeekdayCheckboxRowProps> = ({
  title,
  nonDeliveryDays = [],
  onChange,
  disabled = false,
}) => {
  const classes = useStyles();
  return (
    <Grid container alignItems="center" spacing={2} className={classes.checkboxGrid}>
      <Grid item xs={3} className={classes.title}>
        <Typography>{title}</Typography>
      </Grid>
      {WEEKDAYS.map((day, idx) => (
        <Grid item key={day} xs={1} className={classes.checkboxItem}>
          <Checkbox
            checked={nonDeliveryDays.includes(day)}
            onChange={e => onChange && onChange(idx, e.target.checked)}
            color="primary"
            disabled={disabled}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default WeekdayCheckboxRow;
